module.exports = __webpack_public_path__ + "img/3-drop.5d86aef4.gif";